import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HotjarService {
  constructor() {}

  getInstance() {
    return (window['hj'] = window['hj'] || this._getHotjarQueue());
  }

  actionEvent(action: string, name: string) {
    try {
      this.getInstance()(action, name);
    } catch (err) {
      console.error(err);
    }
  }

  event(eventName: string) {
    this.actionEvent('event', eventName);
  }

  vpv(url: string) {
    this.actionEvent('vpv', url);
  }

  private _getHotjarQueue() {
    return function () {
      (window['hj']['q'] = window['hj']['q'] || []).push(arguments);
    };
  }
}
